import { useState } from "nuxt/app"

export const useGlobalLoading = () => {
  // Stato globale di loading
  const isLoading = useState('global.loading', () => false)
  const loadingMessage = useState('global.loading.message', () => '')

  // Funzioni per gestire lo stato
  const startLoading = (message = 'Loading...') => {
    isLoading.value = true
    loadingMessage.value = message
  }

  const stopLoading = () => {
    isLoading.value = false
    loadingMessage.value = ''
  }

  // Wrapper per operazioni async
  const withLoading = async <T>(
    fn: () => Promise<T>, 
    message = 'Loading...'
  ): Promise<T> => {
    startLoading(message)
    try {
      return await fn()
    } finally {
      stopLoading()
    }
  }

  return {
    isLoading,
    loadingMessage,
    startLoading,
    stopLoading,
    withLoading
  }
}